import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
  Button,
  Menu,
  MenuItem,
  Collapse,
  useMediaQuery,
  useTheme
} from '@mui/material';
import {
  Menu as MenuIcon,
  Home as HomeIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon
} from '@mui/icons-material';
import { NavLink } from 'react-router-dom';
import menuItems from "./../routes"
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";

import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
// NavItem Component
const NavItem = ({ item }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const location = useLocation(); // Get current path
  const [isParentActive, setIsParentActive] = useState(false);

  useEffect(() => {
    if (item.subMenu) {
      // Check if any submenu item matches the current route
      const isActive = item.subMenu.some(subItem => location.pathname.startsWith(subItem.path));
      setIsParentActive(isActive);
    }
  }, [location.pathname, item.subMenu]);

  const handleClick = (event) => {
    if (item.subMenu) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {!item.subMenu ? (
        <NavLink
          to={item.path}
          style={({ isActive }) => ({
            backgroundColor: isActive ? 'rgba(255,255,255,0.2)' : 'transparent',
            color: isActive ? 'white' : 'white',
            textDecoration: 'none',
          })}
          end
        >
          <Button
            color="inherit"
            sx={{
              textTransform: 'none',
              fontSize: '15px',
              '&:hover': { color: '#d5dbd9', backgroundColor: 'rgba(0,0,0,0.2)' },
            }}
          >
            {item.title}
          </Button>
        </NavLink>
      ) : (
        <>
          <Button
            color="inherit"
            onClick={handleClick}
            endIcon={<KeyboardArrowDownIcon />}
            sx={{
              textTransform: 'none',
              fontSize: '15px',
              color: isParentActive ? 'white' : 'white', // Highlight parent if active
              backgroundColor: isParentActive ? 'rgba(255,255,255,0.2)' : 'transparent',
              '&:hover': { color: '#d5dbd9', backgroundColor: 'rgba(0,0,0,0.2)' },
            }}
          >
            {item.title}
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            sx={{
              '& .MuiMenu-paper': {
                background: 'linear-gradient(to right, #1976d2, #512da8)',
                color: '#fff',
                borderRadius: '8px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
              },
            }}
          >
            {item.subMenu.map((subItem) => (
              <MenuItem
                key={subItem.path}
                component={NavLink}
                to={subItem.path}
                onClick={handleClose}
                style={({ isActive }) => ({
                  backgroundColor: isActive ? 'rgba(255,255,255,0.2)' : 'transparent',
                  color: isActive ? 'white' : 'white',
                  textDecoration: 'none',
                })}
                sx={{
                  '&:hover': {
                    backgroundColor: 'rgba(0,0,0,0.2)',
                  },
                }}
              >
                {subItem.title}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </Box>
  );
};


// Main Header Component
const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState({});
  const [isSticky, setIsSticky] = useState(false);
  const navigate = useNavigate();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const theme = useTheme();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTabletOrMobile = useMediaQuery("(max-width: 1368px)");
  console.log(isTabletOrMobile)
  // Targets <=1280px
  // const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));

  // Check if any submenu item's path matches the current URL

  // const handleSubMenuToggle = (index) => {
  //   setOpenSubMenu(prev => ({
  //     ...prev,
  //     [index]: !prev[index]
  //   }));
  // };
  const handleSubMenuToggle = (index) => {
    setOpenSubMenu((prevIndex) => (prevIndex === index ? null : index)); // Toggle logic
  };

  return (
    <>
      {/* Top Info Bar */}
      {!isMobile && (
        <Box
          sx={{
            width: '100%',
            bgcolor: '#fff',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              maxWidth: '1200px',
              mx: 'auto',
              px: { xs: 2, sm: 3 },
              py: { xs: 2, sm: 1.5 },
            }}
          >
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={{ xs: 2, sm: 4 }}
              alignItems="center"
              justifyContent="center"
              divider={
                <Box
                  sx={{
                    display: { xs: 'none', sm: 'block' },
                    width: '1px',
                    height: '20px',
                    bgcolor: 'rgba(0,0,0,0.2)',
                  }}
                />
              }
            >
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                alignItems="center"
                spacing={1}
                sx={{
                  color: '#003733',
                  width: { xs: '100%', sm: 'auto' },
                  textAlign: 'center',
                }}
              >
                <HomeIcon sx={{ fontSize: { xs: '1.2rem', sm: '1.4rem' } }} />
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: '0.8rem', sm: '0.9rem' },
                    maxWidth: { xs: '280px', sm: '600px' },
                    lineHeight: 1.4,
                  }}
                >
                  G-26, Magnus Shopping Centre, Althan Bhimrad Canal Road, Althan Surat, 395017
                </Typography>
              </Stack>

              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{ color: '#003733' }}
              >
                <PhoneIcon sx={{ fontSize: { xs: '1.2rem', sm: '1.4rem' } }} />
                <Typography
                  variant="body2"
                  sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem' } }}
                >
                  +91-88491 49900
                </Typography>
              </Stack>

              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{ color: '#003733' }}
              >
                <EmailIcon sx={{ fontSize: { xs: '1.2rem', sm: '1.4rem' } }} />
                <Typography
                  variant="body2"
                  sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem' } }}
                >
                  jananidhi.29surat@gmail.com
                </Typography>
              </Stack>
            </Stack>
          </Box>
        </Box>
      )}

      {/* Main Navigation Bar */}
      <AppBar
        position={isSticky ? 'fixed' : 'static'}
        sx={{
          background: 'linear-gradient(to right, #1976d2, #512da8)',
          boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
          transition: 'all 0.3s ease',
        }}
      >
        <Toolbar
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            minHeight: { xs: '56px', sm: '64px' },
            px: { xs: 2, sm: 3 },
            gap: 2
          }}
        >
          {/* Logo and Organization Name Container */}
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            flexShrink: 0  // Prevents the logo from shrinking
          }}>
            <Box
              onClick={() => navigate("/")}
              component="img"
              src="/nycs-new-logo.png"
              alt="NYCS Logo"
              sx={{
                display: { xs: 'none', sm: 'block' },
                height: { xs: '50px', sm: '60px' },
                width: 'auto',
                cursor: "pointer"
              }}
            />
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              <Typography
                variant="h6"
                sx={{
                  color: 'white',
                  fontSize: { sm: '1.1rem', md: '1.25rem' },
                  fontWeight: 600,
                  whiteSpace: 'nowrap'  // Prevents text wrapping
                }}
              >
               National Yuva Cooperative Society
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  color: 'white',
                  opacity: 0.9,
                  fontSize: { sm: '0.8rem', md: '0.9rem' }
                }}
              >
                (NYCS)
              </Typography>
            </Box>
          </Box>

          {/* Navigation Menu */}
          <Box
            sx={{
              display: { xs: 'none', sm: 'none', md: 'none', lg: 'flex', xl: 'flex' },
              // display: "flex",
              alignItems: "center",
              justifyContent: { xs: "center", sm: "center", md: "space-between" },
              width: "100%",
              flexWrap: "wrap", // Ensures wrapping on smaller screens
              gap: 1, // Adjust spacing
              paddingX: 2, // Add padding for better spacing
            }}
          >
            {menuItems.map((item) => (
              <NavItem key={item.path} item={item} />
            ))}
          </Box>


          {/* Mobile Menu Button */}
          <IconButton
            color="inherit"
            edge="end"
            onClick={handleDrawerToggle}
            sx={{
              // display: { xs: 'block', md: 'none' },
              display: { xs: 'block', sm: 'block', md: 'block', lg: 'none', xl: 'none' },

              ml: 'auto'  // Pushes the button to the right
            }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>


        {/* Mobile Drawer */}
        <Drawer
          anchor="right"
          // open={mobileOpen}
          open={isTabletOrMobile && mobileOpen}
          onClose={handleDrawerToggle}
          sx={{
            '& .MuiDrawer-paper': {
              width: '250px',
              backgroundColor: '#fff', // Changed to white background
              color: '#000',
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              padding: "16px",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <img
              src="/nycs-new-logo.png"  // Update with your actual logo path
              alt="Company Logo"
              style={{ width: "120px", height: "auto" }}
            />
            <Typography
              variant='body1'
              sx={{
                color: "black",
                fontWeight: "bold"
              }}
            >
              NYCS
            </Typography>
          </Box>
          <List sx={{ pt: 2 }}>
            {menuItems.map((item, index) => (
              <React.Fragment key={item.path}>
                <ListItem disablePadding>
                  {!item.subMenu ? (
                    <ListItemButton
                      component={NavLink}
                      to={item.path}
                      onClick={handleDrawerToggle}
                      style={({ isActive }) => {
                        const isSubItemActive = item.subMenu?.some(subItem =>
                          location.pathname.startsWith(subItem.path)
                        );

                        return {
                          backgroundColor: isActive ? '#e0e0e0' : 'transparent', // Light gray for active
                          color: isActive || isSubItemActive ? '#1976d2' : '#000', // Blue for active text
                          textDecoration: 'none',
                        };
                      }}
                      end
                    >
                      <ListItemText primary={item.title} />
                    </ListItemButton>
                  ) : (
                    <ListItemButton
                      onClick={() => handleSubMenuToggle(index)}
                      sx={{
                        color: '#000',
                        // '&:hover': {
                        //   backgroundColor: '#f5f5f5',
                        // },
                      }}
                    >
                      <ListItemText primary={item.title} />
                      {openSubMenu === index ? <ExpandLessIcon /> : <ExpandMoreIcon />}

                      {/* {openSubMenu[index] ? <ExpandLessIcon /> : <ExpandMoreIcon />} */}
                    </ListItemButton>
                  )}
                </ListItem>

                {item.subMenu && (
                  // <Collapse in={openSubMenu[index]} timeout="auto" unmountOnExit>
                  <Collapse in={openSubMenu === index} timeout="auto" unmountOnExit>

                    <List component="div" disablePadding>
                      {item.subMenu.map((subItem) => (
                        <ListItemButton
                          key={subItem.path}
                          component={NavLink}
                          to={subItem.path}
                          onClick={handleDrawerToggle}
                          style={({ isActive }) => {
                            const isSubItemActive = location.pathname.startsWith(subItem.path);

                            return {
                              backgroundColor: isActive || isSubItemActive ? '#e0e0e0' : 'transparent', // Light gray for active
                              color: isActive || isSubItemActive ? '#1976d2' : '#000', // Blue for active text
                              textDecoration: 'none',
                            };
                          }}
                          end
                        >
                          <FiberManualRecordIcon
                            sx={{
                              fontSize: "10px",
                              marginLeft: "20px",
                              color: location.pathname.startsWith(subItem.path) ? "primary" : "black"
                            }}
                          />
                          <ListItemText
                            sx={{
                              marginLeft: "20px",
                              fontWeight: location.pathname.startsWith(subItem.path) ? "bold" : "none"
                            }}

                            primary={subItem.title} />
                        </ListItemButton>
                      ))}
                    </List>
                  </Collapse>
                )}
              </React.Fragment>
            ))}
          </List>
        </Drawer>
      </AppBar>
    </>
  );
};

export default Header;
{/* <Toolbar sx={{ justifyContent: 'center', minHeight: { xs: '56px', sm: '64px' } }}>
{/* Logo and Organization Name */}
{/* <Box sx={{
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  position: 'absolute',
  left: { xs: '16px', sm: '24px' }
}}>
  <Box
    component="img"
    src="/nycs-logo.png" // Replace with your actual logo path
    alt="NYCS Logo"
    sx={{
      height: { xs: '60px', sm: '70px' },
      width: 'auto'
    }}
  />
  <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
    <Typography
      variant="h6"
      sx={{
        color: 'white',
        fontSize: { sm: '1.1rem', md: '1.25rem' },
        fontWeight: 600
      }}
    >
      National Yuva Coopartive Society (NYCS)
    </Typography>
    {/* <Typography 
variant="subtitle2" 
sx={{ 
color: 'white',
opacity: 0.9,
fontSize: { sm: '0.8rem', md: '0.9rem' }
}}
>

</Typography> */}
// </Box>
{/* <Box
component="img"
src="/nycs-logo.png" // Replace with your actual logo path
alt="NYCS Logo"
sx={{
height: { xs: '40px', sm: '45px' },
width: 'auto'
}}
/> */}
// </Box> */}

{/* <Box
  sx={{
    display: { xs: 'none', md: 'flex' },
    gap: 2,
    justifyContent: 'center',
    flex: 1,
  }}
>

  {menuItems.map((item) => (
    <NavItem key={item.path} item={item} />
  ))}
</Box> */}

{/* <IconButton
  color="inherit"
  edge="end"
  onClick={handleDrawerToggle}
  sx={{
    display: { xs: 'block', md: 'none' },
    position: 'absolute',
    right: 16,
  }}
>
  <MenuIcon /> */}
// </IconButton>
// </Toolbar> */}